/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {AlertsFormComponent} from './alerts-form.component';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {PipesModule} from '../../../shared/pipes/pipes.module';
import {BundlesPipesModule} from '../../../bundles/shared/pipes/bundles-pipes.module';
import {LoadingSpinnerModule} from '../../../shared/loading/loading-spinner/loading-spinner.module';
import {ToastrModule} from 'ngx-toastr';
import {AlertEditableFormModule} from './alert-editable-form/alert-editable-form.module';
import {AlertFormHeaderModule} from './alert-form-header/alert-form-header.module';
import {AlertFormFooterModule} from './alert-form-footer/alert-form-footer.module';

@NgModule({
    declarations: [AlertsFormComponent],
    exports: [
        AlertsFormComponent
    ],
    imports: [
        CommonModule,
        PipesModule,
        BundlesPipesModule,
        LoadingSpinnerModule,
        ToastrModule.forRoot(),
        AlertEditableFormModule,
        AlertFormHeaderModule,
        AlertFormFooterModule
    ]
})
export class AlertsFormModule {
}
